import { Audiences } from '../../api-types/director';
import { Feature } from '../config';

export const isFeatureEnabled = <T extends string>(
  feature: Feature,
  audiences: Audiences,
  audienceIds: T[] = [],
): boolean => {
  const featuredAudiences = audiences[feature];

  if (!featuredAudiences) return false;

  if (audienceIds.length === 0) return false;

  // * `*` has a special meaning. When it is the first value of the audience array, it means all audiences
  if (featuredAudiences[0] === '*') return true;

  return audienceIds.every((audience) => featuredAudiences.includes(audience));
};
